import React from 'react';
import { Link, Redirect } from 'react-router-dom'
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';
import Grid from 'material-ui/Grid';
import store from 'store';
import isLoggedIn from '../helpers/isLoggedIn';

class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      username: 'Unknown',
      password: '',
      error: false,
    }
    this.onSubmit = this.onSubmit.bind(this);
  }

  updateUsername(field) {
    this.setState({ username: field.target.value })
  }

  updatePassword(field) {
    this.setState({ password: field.target.value })
  }

  onSubmit() {
    const { username, password } = this.state;

    this.setState({ error: false });

    if (password === '' || username === '') {
      return this.setState({ error: true });
    }

    store.set('loggedIn', true);
    store.set('username', username);
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.onSubmit();
    }
  }

  render() {

    if (isLoggedIn()) {
      return <Redirect to="/dashboard" />;
    }

    return (
      <div>
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <Paper className="login form">
              <div className="form-header">Health Wear</div>
              <TextField
                placeholder="Username"
                fullWidth={true}
                className="hw-input"
                onChange={this.updateUsername.bind(this)}
              />
              <TextField
                type="password"
                placeholder="Password"
                fullWidth={true}
                className="hw-input"
                onKeyPress={this.handleKeyPress}
                onChange={this.updatePassword.bind(this)}
              />

              <br />
              <Button raised color="primary" center="center" label="Default" className="loginBtn hw-primary-btn" onClick={this.onSubmit}>Login</Button>
              <div className="btn-link-container">
                <Link to='/registration' className="btn-link default">
                  <Button center="center" label="Default" className="hw-default-btn">Create Account</Button>
                </Link>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/Login.js